import * as React from 'react';
import { IError } from '../api/ApiErrors';
import UIFlex, { IUIFlexProps } from './UIFlex';

export interface IUIErrorProps extends IUIFlexProps{
    error:IError;
}

export function UIError ($props: IUIErrorProps) {
    return (
        <UIFlex className="error" flex={$props.flex}>
            {$props.error.error}
        </UIFlex>
    );
}
